import React, {Component} from 'react';
import { connect } from 'react-redux';
import { getFormValues , reduxForm } from 'redux-form';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import DataSection from '../../comps/DataSection/DataSection';
import formFields from '../config/formFields';
import Heading from '@react/react-spectrum/Heading/js/Heading';
import { Translate } from 'react-redux-i18n';

class RegionLanguage extends Component{ 

    constructor()
    {
        super();
        window.scrollTo(0,0);
        this.state = {
            sectionValidation : {}
        }
    }

    updateValidation = (name,value) => {
        let sectionValidation = this.state.sectionValidation;
        sectionValidation[name] = value;
        this.setState({sectionValidation:sectionValidation});
    }

    
    render(){
        this.props.onValidateChange(Object.values(this.state.sectionValidation).every(Boolean));
        const formName = 'registration';
        return <div>
            <Grid>  
                <GridRow>
                    <GridColumn size={[12,8,6,6]} offsetSize={[0,2,3,3]}>
                        <Heading className = "textBold" variant="pageTitle"><Translate value="registration.Welcome" /></Heading>
                        <p><Translate value="registration.ONBPreferredLanguage" /></p>
                        <GridRow>
                            <GridColumn size={[12,6,6,6]} >
                                <DataSection formStates={this.props.formStates} geoPolData={this.props.geoPolData} form={formName} field={formFields.section1} sectionName="section1" updateValidation={this.updateValidation} />
                            </GridColumn>
                        </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
            </div>
    }
}

RegionLanguage = reduxForm({
    form:'registration',
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(RegionLanguage);

function mapStateToProps(state) {
return {
        formStates: getFormValues('registration')(state),// here 'form' is the name you have given your redux form 
        geoPolData: state.common
}
}

export default connect(mapStateToProps)(RegionLanguage);